import a1 from "../../assets/icons/a1.svg";
import a2 from "../../assets/icons/a2.svg";
import a3 from "../../assets/icons/a3.svg";
export const eventTypes = [
  {
    id: 1,
    title: "Exclusive",
    label: "Exclusive",
    description:
      "A private space or the entire venue booked exclusively for your event, ensuring full privacy and no external guests.",
    icon: a1,
  },
  {
    id: 2,
    // title: "Whole venue",
    title: "Semi-private",
    label: "Semi-Private",
    description: "A section of the venue reserved for your group, offering partial privacy while other guests or events may be present nearby.",
    icon: a2,
  },
  {
    id: 3,
    title: "Shared space",
    label: "Shared Space",
    description:
      "A common area with open access, shared with other patrons or events happening at the same time.",
    icon: a3,
  },
];
